import { generateTestId } from "@client-shared";

export const setImportErrorAlertTestId = (identifier: string): string => generateTestId("ImportErrorAlert", identifier);

export const setImportErrorAlertMessageTestId = (identifier: string): string => generateTestId("ImportErrorAlertMessage", identifier);
